import { Outlet } from 'react-router-dom';
import { LayoutProps } from './layout-types';
import { motion } from 'framer-motion';

const ZeroLayout = (props: LayoutProps) => {
  return (
    <motion.div initial={{ opacity: 0 }} whileInView={{ opacity: 1 }}>
      <Outlet context={props} />
    </motion.div>
  );
};

export default ZeroLayout;
